export const DSID = "d372cf0a-d449-4f73-92d4-9a279d35caf1";
export const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";
